import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserProfileService, ModuleService } from './components/mesc/mesc.service';
import { Router, NavigationCancel, NavigationEnd } from '@angular/router';


class ModuleUser {
    GMIN: any;
    Name: string;
    ModuleClaims: any[];
    RoleClaims: any[];

    constructor(data: any) {
        if (data) {
            this.GMIN = data.GMIN;
            this.Name = data.Name;
            this.ModuleClaims = data.ModuleClaims;
            this.RoleClaims = data.RoleClaims;
        } else {
            this.reset();
        }
    }

    reset() {
        this.GMIN = null;
        this.Name = null;
        this.ModuleClaims = [];
        this.RoleClaims = [];
    }
}


@Injectable()
export class AuthenticationService {
    private currentUser: any;
    private currentRoute: string;
    private readonly currentModule: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private readonly publicModules: any[] = ['CTWR'];

    constructor(
        private readonly moduleService: ModuleService,
        private readonly router: Router,
        private readonly userProfileService: UserProfileService,
    ) {
        userProfileService.read('')
            .then(x => {
                if (!x || !x['ModuleClaims']) return;
                this.currentUser = new ModuleUser(x);
                router.navigate([this.currentRoute ? this.currentRoute : '']);
            })

        router.events.subscribe((e) => {
            if (e instanceof NavigationCancel && !this.currentUser) {
                this.currentRoute = e.url;
            }
            if (e instanceof NavigationEnd) {
                this.currentRoute = e.url;
                this.updateCurrentModule();
            }
        });

    }


    /**
     * 
     */
    isClaimValid(url: string): boolean {
        let response: boolean;
        if (!this.currentUser) return false;

        try {
            const path = url.split('/');
            path.shift();
            if (path[0] && path[0].toLowerCase() === 'mesc') path.shift();
            if (path.length === 0) return true;
            const pathModule = path[0].toLowerCase();

            const isAdminPath: boolean = path.some(x => x.toLowerCase().includes('admin'));
            response = this.isRoleAdmin(path) ||
                !isAdminPath && (
                    this.publicModules.some(m => m.toLowerCase() === pathModule) ||
                    this.currentUser.ModuleClaims.indexOf(path[0]) > -1
                );
        } catch (e) { }
        return response;
    }


    /**
     * Return module for current route
     */
    getActiveModule = (): BehaviorSubject<any> => this.currentModule;


    /**
     * 
     */
    getUserRoles = () => this.currentUser.RoleClaims;


    /**
     * 
     */
    getUserGMIN = () => this.currentUser.GMIN;


    /**
     * 
     */
    private updateCurrentModule() {
        if (!this.moduleService.value && !this.moduleService.loading.value) {
            this.moduleService.read('', false)
                .then(x => this.updateModule())
                .catch(e => this.moduleService.handleError);
        } else {
            this.updateModule();
        }
    }


    /**
     * 
     */
    private updateModule() {
        if (!this.moduleService.value) return;
        const path = this.currentRoute.split('/');
        path.shift();
        const match = this.moduleService.value.find(x => x.Name === path[0]);
        if (!this.currentModule.value || this.currentModule.value !== match) this.currentModule.next(match);
    }


    /**
     * 
     * @param path 
     * 
     * example: /MESC/CTWR/Administration
     */
    private isRoleAdmin(path: string[]): boolean {
        return this.currentUser.RoleClaims.some(x => {
            const claim: string[] = x.split(':');
            const role: string = claim.pop().toLowerCase();
            const module: string = claim.pop().toLowerCase();
            const isUserAdmin = role.includes('admin') && module.includes('user')
            const isMescAdmin = role.includes('admin') && module.includes('mesc');
            return this.isValidAdmin(role, module, path, isUserAdmin, isMescAdmin);
        });
    }

    /**
     * 
     * @param role 
     * @param path 
     * @param isUserAdmin 
     * @param isMescAdmin 
     */
    private isValidAdmin(role, module, path, isUserAdmin, isMescAdmin): boolean {
        const pathModule = path[0].toLowerCase();
        let isValid: boolean;
        switch (pathModule) {
            case 'administration':
                if (path[1]) {
                    if (path[1].toLowerCase() === 'security') {
                        isValid = isMescAdmin || isUserAdmin;
                    } else if (path[1].toLowerCase() === 'maintenance') {
                        isValid = isMescAdmin;
                    }
                } else {
                    isValid = isMescAdmin || isUserAdmin;
                }
                break;
            case 'phf':
            case 'ctwr':
                isValid = role.includes('admin') && module.includes('ctwr');
                break;
            default:
                isValid = isMescAdmin;
                break;
        }
        return isValid;

    }

}
